import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InquiryBriSyariahComponent } from './inquiry-bri-syariah/inquiry-bri-syariah.component';
import { PaymentBriSyariahComponent } from './payment-bri-syariah/payment-bri-syariah.component';
import { SharedComponentModule } from 'src/app/shared/component/shared-component.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentResultBriSyariahComponent } from './payment-result-bri-syariah/payment-result-bri-syariah.component';
import { DirectiveModule } from '@shared/directive/directive.module';

@NgModule({
  declarations: [
    InquiryBriSyariahComponent,
    PaymentBriSyariahComponent,
    PaymentResultBriSyariahComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentModule,
    DirectiveModule
  ]
})
export class BriSyariahModule { }
